// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Lieferant } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetLieferant(): (id: string) => Promise<Lieferant> {
  const getAPI = useGetApi();
  return useCallback(
    async (id) => (await getAPI()).lieferanten.getLieferant({ id }),
    [getAPI]
  );
}
